<div class="navbar navbar-expand-md flex-md-column position-sticky">
  <div class="container-fluid app-navbar">
    <div class="btn-group" dropdown [isAnimated]="true" [autoClose]="true">
      <button
        class="navbar-btn dropdown-toggle navbar-toggler"
        type="button"
        [attr.aria-expanded]="!isNavbarCollapsed"
        dropdownToggle
        type="button"
        aria-controls="dropdown-basic"
        aria-label="Toggle navigation"
      >
        <ng-icon name="lucideMenu" class="text-white"></ng-icon>
      </button>
      <div
        id="dropdown-basic"
        style="width: 240px"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        aria-labelledby="button-basic"
      >
        <dx-tree-view
          [items]="navBarItems"
          displayExpr="name"
          [selectByClick]="false"
          [width]="'260px'"
          [height]="'320px'"
          [rtlEnabled]="true"
          [showExpandAll]="false"
          [showFirstSubmenuMode]="'onClick'"
          (onItemClick)="navItemClick($event)"
        ></dx-tree-view>
      </div>
    </div>

    <div class="d-md-flex ms-md-4 mx-auto">
      <div class="col-lg-auto text-center me-2">
        <img
          src="/assets/images/afra-school.svg"
          alt="لوگوی افرا"
          style="height: 32px"
        />
      </div>
      <div class="col-lg-auto d-flex align-items-center text-center">
        <h6 class="text-white clickable m-0 mt-2" [routerLink]="'/'">
          {{ systemNameLabel }}
        </h6>
      </div>
    </div>
    <div class="btn-group" dropdown [isAnimated]="true" [insideClick]="true">
      <button
        class="dropdown-toggle navbar-btn border-0 bg-transparent position-relative"
        type="button"
        dropdownToggle
        aria-controls="dropdown-basic"
        aria-label="Toggle navigation"
      >
        <ng-icon name="lucideBell" class="text-white fs-4"></ng-icon>
        <span
          class="m-2 bg-danger d-block position-absolute top-0 end-0"
          style="width: 6px; height: 6px; border-radius: 50%"
          *ngIf="unseenNotifCount + unseenMessageCount > 0"
        ></span>
      </button>
      <div
        id="dropdown-basic"
        style="width: 270px"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="button-basic"
      >
        <app-notificatoins-and-messages-dropdown
          [notifications]="notificationsResponse"
          [messages]="messagesResponse"
        ></app-notificatoins-and-messages-dropdown>
      </div>
    </div>
    <div class="text-center text-lg-end my-2 me-md-5">
      <app-auth-bar></app-auth-bar>
    </div>
  </div>
  <div class="w-100 bg-success-subtle bg-gradient ps-4">
    <ul class="navbar-nav flex-row gap-3 mr-auto d-none d-md-flex">
      <ng-container *ngFor="let item of navBarItems">
        <li class="nav-item dropdown" *ngIf="item.items" dropdown>
          <a
            class="nav-link dropdown-toggle d-flex align-items-center"
            id="navbarDropdown"
            [attr.aria-expanded]="false"
            aria-haspopup="true"
            data-bs-toggle="dropdown"
            data-toggle="dropdown"
            role="button"
            dropdownToggle
          >
            {{ item.name }}
            <ng-icon
              name="lucideChevronLeft"
              class="me-1"
              size="18"
              [style]="{ transform: 'rotate(-90deg)' }"
            ></ng-icon>
          </a>
          <div
            *dropdownMenu
            aria-labelledby="navbarDropdown"
            class="dropdown-menu dropdown-menu-right"
            role="menu"
          >
            <ng-container *ngFor="let subItem of item.items">
              <li class="dropdown-item">
                <a class="nav-link" [routerLink]="subItem.urlParts.join('/')">
                  {{ subItem.name }}
                </a>
              </li>
            </ng-container>
          </div>
        </li>
        <li class="nav-item" *ngIf="!item.items">
          <a
            class="nav-link"
            [routerLink]="item.urlParts.join('/')"
            [routerLinkActive]="'active'"
          >
            {{ item.name }}
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
<!-- #7cde7c -->
